<template>
  <div v-loading="loading">
    <!-- 头部start -->
    <crumbs :activeIndex="3"></crumbs>
    <!-- 头部 end-->
    <!-- 广告start -->
    <div class="y-advertisement">
      <img src="../../static/img/preview.png" alt />
    </div>
    <!-- 广告end -->
    <!-- 导航start -->
    <div class="y-navigation">
      <div class="min y-navigation-box">
        <div class="router-active">
          <img src="../../static/img/icon.png" alt />
          <router-link to="/">首页 ></router-link>预约订票>
          <span style="color: #0078ff">{{ person }}</span>
        </div>
        <div class="y-navigation-select">
          <ul>
            <li
              class
              v-for="(item, index) in navigationArr"
              @click="selectNavFun(index, item)"
              :key="index"
              :class="[index == selectIndex ? 'active' : '']"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 导航end -->

    <!-- 预约日期 start-->
    <div class="appointment-date min" v-show="selectIndex == 0">
      <h4>请选择预约日期</h4>

      <el-calendar :range="['{{startDate}}', '{{endDate}}']">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{ data }">
          <div @click="frameFun(data)" style="width: 100%">
            <div style="height: 100px; font-size:16px; padding-top: 24px; box-sizing: border-box;">
              {{ data.day.split("-").slice(1).join("-") }}
              <div v-for="(item, index) in selectList" :key="index">
                <div
                  v-if="item.day == data.day.split('-').slice(1).join('-')"
                  class="dayys"
                >
                  余 {{ item.remaining }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-calendar>

      <div class>
        <div class="expectPeriodTimeClass">
          <!-- <div class="appointment-p-time">预约时段</div> -->
          <el-form >
            <el-form-item  label="* 预约时段"   prop="expectPeriodTime"  >
              <el-select  v-model="expectPeriodTime" clearable placeholder="请选择" @change="changeExpectFun" @clear="expectPeriodTime = ''">
                <el-option
                  v-for="item in expectTimeList"
                  :key="item.expectPeriodTime"
                  :label="item.expectPeriodTime"
                  :value="item.expectPeriodTime"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form >
        </div>
        <h4>请填写个人信息</h4>
        <el-form ref="addPeoplForm" :inline="true" :rules="rules" :model="formdynamicItem" >
          <div class="appointment-period min"   >
            <div class="appointment-p-item">
              <el-form-item  label="姓名"  prop="leaderName" >
                <el-input
                  v-model="formdynamicItem.leaderName"
                  maxlength="18"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </div>
            <div class="appointment-p-item">
              <el-form-item  label="证件类型" prop="papers">
                <el-select v-model="formdynamicItem.papers" placeholder="请选择">
                  <el-option
                    v-for="item in option"
                    :key="item.papers"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="appointment-p-item">
              <el-form-item label="证件号码" prop="leaderIdCard">
                <el-input
                  v-model="formdynamicItem.leaderIdCard"
                  maxlength="18"
                  placeholder="请输入证件号码"
                ></el-input>
              </el-form-item>
            </div>
            <div class="appointment-p-item">
              <el-form-item label="手机号" prop="phone">
                <el-input
                  v-model="formdynamicItem.phone"
                  maxlength="11"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
            </div>
            <div
              class="appointment-p-item"
              style="width: 20%; display: flex; align-items: flex-end"
            >
              <el-form-item>
                <el-button   @click="addPeopleFun()"  type="text"  >
                  <span class="appointment-p-item-pull">
                    <img
                      src="../../static/img/additional.png"
                      class="appointment-p-item-img"
                      alt
                    />添加人员
                  </span>
                </el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div  v-for="(item, index) in userList"  :key="index" class="userNameList" >
          <div class="usernamelist">
            <el-checkbox  v-model="item.status" size="medium" @change="selectPeopleFun(index, item)" ></el-checkbox>
            <div class="userName"><span>姓名：</span> {{ item.userName }}</div>
            <div class="idCode">证件号： {{ item.idCode }}</div>
            <div class="phone">电话：{{ item.phone }}</div>
          </div>
          <div class="user-delte" @click="deleteUser(item)">刪除</div>
        </div>
        <!-- 提交预约start -->
        <div class="submit-appointment">
          <el-button
            type="text"
            @click="subOrder"
            style="
              font-size: 16px;
              color: #ffffff !important;
              font-weight: bold;
            "
            >提交预约</el-button
          >
        </div>
        <!-- 提交预约end -->
        <div class="tourist">
          <h4>游览指南</h4>
          <div class="tourist-box min">
            <div class="ourist-box-text">
              <h4 style="padding-bottom: 0px;padding-top:30px">开放时间</h4>
              <p>
                根据观众参观需求，朔州市科学技术馆决定从2021年10月21日起开馆
              </p>
              <p>开放时间：周三至周日9:00—17:00</p>
              <p>闭馆时间：周一，周二（国家法定节假日除外）</p>
            </div>

            <div class="ourist-box-text">
              <h4 style="padding-bottom: 0">预约须知</h4>
              <p>
                一、朔州市科学技术馆售票形式为预约制，本馆开放期间广大观众可通过“朔州市科学技术馆”门户网站（http://www.sxszstm.com/）或者官方微信公众号（“朔州市科学技术馆”）进行线上预约；并在预约时间段凭电子门票入馆参观.
              </p>
              <p>
                二、接待个人预约时间为每周六、周日。
              </p>
              <p>
                三、接待团体预约时间为每周三、周四、周五（国家法定节假日除外）。团体参观须提前15日致电馆内进行预约，并需提交相关材料信息和签署相关协议。
              </p>
              <p>
                四、老年人、学龄前儿童、未成年学生、残疾等特殊群体观众，须由监护人陪同参观和参与互动项目，并全程负责安全。
              </p>
              <p>
                五、严禁携带管制刀具、利器、易燃、易爆、有毒、有害等危险物品进馆，馆内严禁明火、吸烟;贵重物品请随身携带并安善保管，大件物品须寄存
              </p>
              <p>
                六、请广大入馆的观众文明有序参观，严格遵守科技馆参观须知以及工作人员的指引和相关的规定。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appointment-date min" v-show="selectIndex == 1">
      <h4>请选择预约日期</h4>

      <!-- v-model="expectTime" -->
      <!-- {{startDate}} {{endDate}} -->
      <el-calendar>
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{ data }">
          <div @click="frameFun(data)" style="width: 100%; height: 100%">
            <div style="height: 40px;font-size:16px;padding-top: 24px; box-sizing: border-box;">
              {{ data.day.split("-").slice(1).join("-") }}
              <div v-for="(item, index) in selectList" :key="index">
                <div
                  v-if="item.day == data.day.split('-').slice(1).join('-')"
                  class="dayys"
                >
                  余 {{ item.remaining }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-calendar>
      <div class>
        <div class="ifile-btn">
          <h4>请填写单位信息
           <span style="font-size: 14px; color: #ccc;width: 700px;   vertical-align: middle;  display: inline-block;">
                预约流程：下载模板 -->填写完信息—>导入—>  然后选择预约时间 ,填写单位名称,团队人数，负责人信息-->提交 注意：只有在excel表格里的添加的人员信息才能通过闸机检票</span>
          </h4>
          <excel @excelDataName="excelFun"></excel>
        </div>
        <el-form ref="forms" :inline="true" :model="forms" label-width="100%">
          <div
            class=" min" style="display:flex;     justify-content: space-between;"
            v-for="(item, index) in forms.dynamicItem"
            :key="index"
          >
            <div class=""  style="width:24%;" >
              <!-- <div class="appointment-p-time">预约时段</div> -->
              <el-form-item
                style="width:100%;"
                label="预约时段"
                :prop="'dynamicItem.' + index + '.expectPeriodTime'"
              >
                <el-select v-model="item.expectPeriodTime" placeholder="请选择" style="width:100%;">
                  <el-option
                    v-for="item in expectTimeList"
                    :key="item.expectPeriodTime"
                    :label="item.expectPeriodTime"
                    :value="item.expectPeriodTime"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class=""   style="width:24%;">
              <!-- <div class="appointment-p-time">单位名称</div> -->
              <el-form-item label="单位名称"    style="width:100%;"  >
                <el-input
                  v-model="item.gName"
                  maxlength="18"
                  placeholder="请输入单位名称"
                ></el-input>
              </el-form-item>
            </div>
            <div class=""   style="width:24%;">
              <el-form-item label="团队人数"       style="width:100%;"  >
                <el-input
                  v-model="item.groupSum"
                  maxlength="4"
                  placeholder="请输入团队人数"
                ></el-input>
              </el-form-item>
            </div>
            <div
              class=""
              style="width: 25%; display: flex; align-items: flex-end; "
            >
              <el-form-item  style="width:100%;     text-align: center; "  >
                <el-button v-if="index <= 5" @click="addItem" type="text" style="width:100%;    height: 40px;     line-height: 10px;    border: 1px dashed #ccc;">
                  <span class="appointment-p-item-pull" style="    justify-content: center;">
                    <img
                      src="../../static/img/additional.png"
                      class="appointment-p-item-img"
                      alt
                    />添加负责人信息
                  </span>
                </el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <!-- 提交预约start -->
        <div class="submit-appointment" @click="SendPhoneCodeFun(forms)" style="float:right;border-radius: 0;">
          提交预约
        </div>
        <div class="tourist">
          <h4>游览指南</h4>
          <div class="tourist-box min">
            <div class="ourist-box-text">
              <h4 style="padding-bottom: 0px;padding-top:30px">开放时间</h4>
              <p>
                根据观众参观需求，朔州市科学技术馆决定从2021年10月21日起开馆
              </p>
              <p>开放时间：周三至周日9:00—17:00</p>
              <p>闭馆时间：周一，周二（国家法定节假日除外）</p>
            </div>
            <div class="ourist-box-text">
              <h4 style="padding-bottom: 0">预约须知</h4>
              <p>
                一、朔州市科学技术馆售票形式为预约制，本馆开放期间广大观众可通过“朔州市科学技术馆”门户网站（http://www.sxszstm.com/）或者官方微信公众号（“朔州市科学技术馆”）进行线上预约；并在预约时间段凭电子门票入馆参观.
              </p>
              <p>
                二、接待个人预约时间为每周六、周日。
              </p>
              <p>
                三、接待团体预约时间为每周三、周四、周五（国家法定节假日除外）。团体参观须提前15日致电馆内进行预约，并需提交相关材料信息和签署相关协议。
              </p>
              <p>
                四、老年人、学龄前儿童、未成年学生、残疾等特殊群体观众，须由监护人陪同参观和参与互动项目，并全程负责安全。
              </p>
              <p>
                五、严禁携带管制刀具、利器、易燃、易爆、有毒、有害等危险物品进馆，馆内严禁明火、吸烟;贵重物品请随身携带并安善保管，大件物品须寄存
              </p>
              <p>
                六、请广大入馆的观众文明有序参观，严格遵守科技馆参观须知以及工作人员的指引和相关的规定。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 预约日期 end-->
    <div class v-show="selectIndex == 2" >
      <!-- 我的预约start-->
      <div class="appointment">
        <div class="appointmenttopClass min">
          <div class="appointment-list">
            <div
              class="a-l-item"
              @click="selectUser(1)"
              :class="{ 'a-l-active': isIndex == 1 }"
            >
              未使用
            </div>
            <div
              class="a-l-item"
              @click="selectUser(3)"
              :class="{ 'a-l-active': isIndex == 3 }"
            >
              已使用
            </div>
            <div
              class="a-l-item"
              @click="selectUser(21)"
              :class="{ 'a-l-active': isIndex == 21 }"
            >
              已取消
            </div>
          </div>
        </div>
        <div
          class="appointment-info min"
          v-for="(hot, index) in hotList"
          :key="index"
        >
          <div class="appointment-info-status">
            <div class="a-i-s-b" v-if="hot.status == 1"></div>
            <div class="a-i-s-c" v-if="hot.status == 3"></div>
            <div class="a-i-s-d" v-if="hot.status == 21"></div>
          </div>
          <div class="appointment-info-left">
            <div class="a-info-time">预约时间 {{ hot.playDate }}</div>
            <div class="a-info-visitors">
              参观人数
              <span>{{ hot.number }}</span>
            </div>
          </div>
          <div class="appointment-info-right" v-if="hot.status == 1 || hot.status == 3">
            <div class="reservation" v-if="hot.status == 1" @click="cancelFun(hot)">取消预约</div>
            <div class="a-details">
              <el-button
                type="text"
                style="color: #ffffff !important"
                @click="personageFun(hot)"
                >查看详情</el-button
              >
            </div>
          </div>
        </div>
         <div
          class="appointment-info min"
          v-if="hotList.length ==0"
        >
          <p>暂无相关信息</p>
        </div>
      </div>
      <!-- 我的预约end -->
    </div>
      <el-dialog
        class="el-dialog-content"
        title="检票二维码"
        :visible.sync="centerDialogVisible"
        width="100%"
        center
        style="top: 12%"
        :close-on-click-modal="false"
      >
       <div  v-for="(item,index) in codeList" :key="index">
        <span style="font-size: 13px"
          >凭此二维码在场馆入口扫码入馆 （支持刷身份证入馆）</span
        >
        <span class="dialog-footer">
          <div class="qrcode" :id="'qrcode'+index"></div>
          <!-- <img class="qrcode" src="../../static/img/code.png" alt=""> -->

          <span class="el-dialog-order">
            网站预约成人票
            <p>({{ format }})</p>
          </span>
          <span class="el-dialog-spread">
            <p>1</p>
            /
            <p>{{item.number}}张</p>
          </span>
        </span>
        <span slot="footer" class="bottom">
          <span class="el-dialog-papers">
            <p>姓名</p>
            <p>{{item.userName}}</p>
          </span>
          <span class="el-dialog-papers">
            <p>证件号码</p>
            <p>{{ item.idCode }}</p>
          </span>
          <span class="el-dialog-papers">
            <p>预约时间</p>
            <p>{{ item.hotelArriveTime }}</p>
          </span>
          <span class="el-dialog-paperse">
            <p>状态</p>
            <p v-if="item.status == 0">待使用</p>
            <p v-if="item.status == 1">已使用</p>
            <p v-if="item.status == 2">已取消</p>
          </span>
        </span>
        </div>
      </el-dialog>
    <el-dialog
      title="预约须知"
      :visible.sync="dialogVisiblerse"
      class="el-dialog-notice"
      width="1000px"
      style="top: 7%; box-shadow: none"
    >
      <span>
        <p>
          朔州市科学技术馆实行实名制购检票，请您合理安排出行时间，务必按预约时段凭相关证件检票入馆。
        </p>
        <p>一、预约入馆措施</p>
        <p>
          1．所有观众（含免费）均需填写本人有效实名证件信息进行预约购票，入馆需凭购票时填写的本人有效实名证件进行检票，享受优惠票和免费票的观众需同时出示相关证件。
        </p>
        <p>
          2．参观当日请携带相关证件检票入馆，观众参观入馆请自觉出示订单信息，进入行程码小程序进行现场扫码登记，排队保持一米间隔，配合工作人员测量体温和安检。证件不全、健康码异常、体温异常（≥37.3°C）的观众谢绝入馆。
        </p>
        <p>
          二、疫情防控期间开放时间
          星期三至星期日9：00-17：00（16：30停止检票），星期一，星期二（国家法定节假日除外）闭馆。
        </p>
        <p>
          三、疫情防控期间开放范围
          开放范围：主展厅、儿童科学乐园、特效影院及短期展厅。封闭改造区域：主展厅“科技与生活”B厅、D厅。本馆开放部分现场教育活动和科学表演；暂停主动辅导服务，展厅工作人员仅在安全距离对观众提出的疑难问题答疑解惑。
        </p>
        <p>四、参观须知</p>
        <p>
          1．参观期间须全程佩戴口罩，请保持参观距离，服从工作人员指挥，做好个人防护，文明参观。
        </p>
        <p>
          2．当展厅内某区域观众密度较大时，现场工作人员将采取相关疏导限流措施，请观众予以配合。
        </p>
        <p>3．参观期间，如身体不适，请及时与展厅工作人员联系。</p>
        <p>
          4．朔州市科学技术馆将视疫情变化而调整相关服务措施，敬请关注官网（www.sxszstm.com）、微信公众号（朔州市科学技术馆）了解最新信息。
        </p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="el-dialog-btn"
          v-if="expectType == 2"
          @click="groupFun(forms)"
          style="
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
            display: flex !important;
            margin: 0 auto;
            margin-top: 30px;
          "
          >{{ buttonmsg }}</el-button
        >

        <el-button
          type="primary"
          class="el-dialog-btn"
          v-if="expectType == 1"
          @click="submit()"
          style="
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
            display: flex !important;
            margin: 0 auto;
            margin-top: 30px;
          "
          >{{ buttonmsg }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="el-dialog-region"
      title="负责人信息"
      :visible.sync="dialogForm"
      width="385px"
      height="390px"
      style="border-radius: 15px; top: 27%"
    >
      <el-form  >
        <el-form-item label="姓名 " class="el-dialog-label">
          <el-input v-model="formhall.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="证件号码" class="el-dialog-label">
          <el-input v-model="formhall.Idcard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" class="el-dialog-label">
          <el-input v-model="formhall.phone" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogForm = false">取 消</el-button>
        <el-button type="primary" @click="affirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- <notice ></notice> -->
    <tab></tab>
    <!-- 底部 start-->
    <Footer></Footer>
    <!-- 底部 end-->
  </div>
</template>

<script>
import tab from "@/components/tab.vue";
import excel from "@/components/excel.vue";
// import notice from "@/components/notice.vue"
import QRCode from "qrcodejs2";
export default {
  components: {
    tab,
    excel,
  },
  data() {
    return {
      userArr:[],
      excelData: [],
      codeList:[],
      isIndex: 1,
      content: {
        name: "",
        idcard: "",
        time: "",
        sum: "",
        status:"",
      },
      loading:false,
      frequentContact: "",
      info: "",
      userId: "",
      teamId: "",
      telPhone: "",
      appUrl: window.SITE_CONFIG.baseApiUrl,
      person: "个人预约",
      centerDialogVisible: false, //预约详情控制
      navigationArr: ["个人预约", "团体预约", "我的预约"],
      selectIndex: "",
      hotList: [],
      dateTime: "",
      expectPeriodTime: "", // 预约的时间段
      isShelves: "闭馆",
      selectList: [],
      expectTimeList: [],
      userList: "",
      option: [
        {
          value: "身份证",
          label: "身份证",
        },
        {
          value: "学生证",
          label: "学生证",
        },
        {
          value: "护照",
          label: "护照",
        },
      ],
      formhall: [
        {
          name: "",
          region: "",
          Idcard: "",
          phone: "",
        },
      ],
      formdynamicItem: {
            name: "",
            leaderName: "",
            idCard: "",
            expectType: 1,
            expectTime: new Date(),
            expectChannel: 1,
            certificateType: "",
            state: 0,
            leaderIdCard: "",
            gName: "",
            groupSum: 0,
            phone: "",
      },
      rules: {
        // expectPeriodTime: [
        //   { required: true, message: '请选择时间', trigger: 'change' },
        // ],
        leaderName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/, message: '只能输入中文英文' },
        ],
        papers: [
             { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        leaderIdCard: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,message: '证件号码不正确' , trigger: 'blur'},
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '电话不正确' , trigger: 'blur'},
        ],
      },

      frame: "",
      papers: "",
      name: "",
      idCard: "",
      expectTime: new Date(),
      unit: "",
      count: "",
      director: "",
      phone: "",
      format: "",
      sum: "",
      // expectTime: "",
      leaderIdCard: "",
      leaderName: "",
      state: "",
      dialogVisiblerse: false, //预约规则
      ticketId: null, // 预约 票id
      buttonmsg: "我已阅读并同意",
      endDate: "2021-09-01",
      startDate: "",
      startDateNow: "",
      time: "",
      forms: {
        dynamicItem: [
          {
            leaderName: "",
            expectType: 2,
            expectPeriodTime: "",
            expectTime: new Date(),
            expectChannel: 1,
            certificateType: "",
            state: 0,
            leaderIdCard: "",
            gName: "",
            groupSum: "",
          },
        ],
      },
      expectType: 1,
      dialogForm: false,
      formLists: {},
      dataList: [], // 获取日期列表
      dateNow: "",
      soulId: "",
    };
  },
  created() {
    this.dateNow = new Date()
      .toISOString()
      .replace(/T/g, " ")
      .replace(/\.[\d]{3}Z/, "")
      .split("-")
      .slice(1)
      .join("-")
      .split(" ")
      .slice(0, 1)
      .join("");
    this.appionGetListFun();
  },
  mounted() {
    if (this.$route.query.selectIndex == undefined) {
      this.selectIndex = 0;
    } else {
      this.selectIndex = this.$route.query.selectIndex;
    }
    this.appionGetListFun();
    var info = JSON.parse(sessionStorage.getItem("info"));
    this.info = info;
    this.userId = info.Id;
    this.getUserList();
  },
  methods: {
    // 判断是否选择 日期
    changeExpectFun(e){
      if(this.expectTimeList.length === 0){
          this.$message({
          showClose: true,
          message: "请新选择有票的日期",
          type: "warning",
        });
      }else{
        console.log(this.expectPeriodTime)
      }
    },
    //获取时段
    frameFun(data) {
      this.loading=true
      this.$https.get("/wxshopapi/ExpectManager/GetExpectPeriodTime", { ExpectDate: data.day })
        .then((res) => {
          this.loading=false
          if (res.data.result) {
            this.ticketId = this.dataList.find(item => item.day === data.day).id
            this.dateTime = data.day;
            this.expectTimeList = res.data.result;
            if(res.data.result.length>0){
              this.expectPeriodTime=this.expectTimeList[0].expectPeriodTime;
            }
          } else {
             this.$confirm('此日期暂无余票，请新选择其他日期', '提示', {
                cancelButtonText: '取消',
                showCancelButton: false,
                type: 'warning'
              })
            this.dateTime = '';
            this.expectTimeList = [];
          }
        }).catch(err=>{
           this.loading=false
        });
    },
    // 根据时段获取 id？
    getDateIdFun(datatime){
      let isShow = this.dataList.findIndexOf(item => item.day === datatime)

    },
    //  添加人员
    addPeopleFun() {
      let Status = sessionStorage.getItem("Status");
      if (Status === null || Status === undefined) {
        this.$message({
          showClose: true,
          message: "请登录后查看",
          type: "warning",
        });
      } else {
        this.$refs.addPeoplForm.validate((valid) => {
          if (valid) {
           this.addPeopleSubmit();
          } else {
            return false
          }
        })
      }
    },
    // 提交数据  预约
    addPeopleSubmit() {
      var that = this;
      var person = {
        codeType: "身份证",
        idCode: this.formdynamicItem.leaderIdCard,
        phone: this.formdynamicItem.phone,
        img: "",
        userId: this.userId,
        userName: this.formdynamicItem.leaderName,
      };
      this.loading = true
      this.$https.post(that.appUrl + "wxshopapi/TouristInfo/AddTouristInfo", person)
        .then((res) => {
          this.loading = false
          if (res.data.success) {

            this.formdynamicItem.leaderName="";
            this.formdynamicItem.phone="";
            this.formdynamicItem.papers="身份证";
            this.formdynamicItem.leaderIdCard="";
            this.getUserList();
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
            });
          }
        }).catch(err=>{
           this.loading = false
        });
    },
    // 个人 预约须知
    sumitPeopleFun(){
      let time = 10;
      let timer;
      timer = setInterval(() => {
        time--;
        if (time === 0) {
          clearInterval(timer);
          this.flag = false;
          this.buttonmsg = "我已阅读并同意";
          return;
        }
        this.flag = true;
        this.buttonmsg = "我已阅读并同意" + time + "s";
      }, 1000);
      this.dialogVisiblerse = true;
    },
    // 个人预约
    submit() {
      let that = this;
      this.dialogVisiblerse = false;
      var data = {
        channel: 2,
        couponAmount: 0,
        frequentContact: this.frequentContact,
        idCardNo: "",
        isGroupBooking: "0",
        isGroupBookingMainUser: "1",
        is_minipg: "0",
        mainUserId: "",
        number: this.frequentContact.length,
        openId: this.info.OpenId,
        orderNo: "",
        orderTotalAmount: 0,
        payType: 1,
        // playEndTime: this.expectPeriodTime,
        playEndTime: null,
        phoneNum: this.telPhone,
        playDate: this.dateTime,
        productId:"2ff841a5-81ed-4dae-aaf6-27919a75ac2c",
        // 2ff841a5-81ed-4dae-aaf6-27919a75ac2c
        // productId: "91f35a8c-66ab-46c2-9fed-4c7b0a6af774",
        productTotalAmount: 0,
        userId: this.info.Id,
        voucherCode: "",
      };
      this.loading=true;
      // 下单
      this.$https.post(this.appUrl + "wxshopapi/Orders/AddTicketOrder", data)
        .then((res) => {
          this.loading=false;
          if (res.data.success == false) {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
            });
          } else {
            this.frequentContact=[];
            this.userList.map(function(item){
                item.status=false;
                return item;
            })
            this.$message({
              type: 'success',
              message: "预定完成,正在请求出票...",
              duration:5000,
              onClose:function(){
                that.selectIndex = 2;
                that.selectUser(1);
              }
            });
          }
        }).catch(err=>{
          this.loading=false;
        });
    },
    //  提交订单 减库存
    reduceStockFun( num){
       this.loading=true;
      this.$https.post(this.appUrl +"wxshopapi/ExpectManager/UpdateExpectReduction", {dateTime: this.dateTime, expectPeriodTime: this.expectPeriodTime, num: num })
        .then((res) => {
          this.loading=false;
          if (res.data.success) {
            let time = 10;
            let timer;
            timer = setInterval(() => {
              time--;
              if (time === 0) {
                clearInterval(timer);
                this.flag = false;
                this.buttonmsg = "我已阅读并同意";
                return;
              }
              this.flag = true;
              this.buttonmsg = "我已阅读并同意 " + time + "s";
            }, 1000);
            this.dialogVisiblerse = true;
          }else{
            this.$message({
              showClose: true,
              type: "error",
              message: "提交预约失败,请重试",
            });
            this.appionGetListFun();
          }
      }).catch(err=>{
          this.loading=false;
        });
    },
    //提交订单
    subOrder() {
      let Status = sessionStorage.getItem("Status");
        if (Status === null || Status === undefined) {
        this.$message({
          message: "请登录后查看",
          type: "warning",
        });
       return;
      }
      if(this.dateTime==""){
        this.$message({ type: "error", message: "请选择预约日期", });
        return;
      } else if (this.expectPeriodTime == "") {
        this.$message({ showClose: true, type: "error",message: "请选择预约时段", });
        return;
      } else  if (this.frequentContact.length <= 0) {
        if(this.formdynamicItem.leaderName==""){
          this.$message({ type: "error", message: "姓名不能为空", });
        return;
        }
        if(this.formdynamicItem.papers==""){
          this.$message({ type: "error", message: "证件类型不能为空", });
        return;
        }
        if(this.formdynamicItem.leaderIdCard==""){
          this.$message({ type: "error", message: "证件不能为空", });
        return;
        }
      } else {
          this.reduceStockFun(this.frequentContact.length)
      }
    },
    //删除联系人
    deleteUser(item){
      this.$https.post(this.appUrl +"wxshopapi/TouristInfo/DeleteTouristInfo", { id:item.id })
        .then((res) => {
          if (res.data.success) {
            this.$message({  showClose: true, type: "error", message: "删除成功",  });
            this.getUserList();
          } else {
            this.$message({  showClose: true,  type: "error", message: "删除失败", });
          }
        });
    },
    // 查看详情时间
    GetModelByOrderNo(id){
      this.$https.get(this.appUrl + "wxshopapi/Orders/GetModelByOrderNo", { orderNo:id })
        .then((res) => {
          if (res.data.success) {
            this.content.time=res.data.result.playDate
          }
        });
    },
    //取消预约
    claearYUYue(id, orderNumber) {
      var that = this;
      var obj = {
        orderDetailIds: id.join(','),
        orderNo: orderNumber,
        remark: "取消预约",
      };
      this.$https.post(that.appUrl + "wxshopapi/Orders/AddRefundApply", obj)
        .then((res) => {
          that.loading=false
          if (res.data.success) {
            this.$message({
              showClose: true,
              type: "success",
              message: "操作成功",
            });
            this.GetUserOrderPageListFun(1);
          }
        }).catch(err=>{
          that.loading=false
        });
    },
    //生成微信二维码
    wxCode(id, callback) {
      var that = this;
      var obje = {
        orderNumber: id,
        pageindex: 1,
        pageSize: 1000,
      };
      this.$https.get(that.appUrl + "wxshopapi/Orders/GetOrderDetailsPageList", obje)
        .then((res) => {
          if (res.data.success) {
             var list=res.data.result.rows;
              callback(list);
          }
        });
    },
    selectUser(index) {
        let Status = sessionStorage.getItem("Status");
        var that = this;
        if (Status === null || Status === undefined) {
          that.$message({
            showClose: true,
            message: "请登录后查看",
            type: "warning",
          });
        } else {
          this.isIndex = index;
          this.GetUserOrderPageListFun(this.isIndex);
        }
    },
    //是否注册
    isCard(data, callback) {
      var that = this;
      this.$https
        .get(that.appUrl + "wxshopapi/Tickets/GetQualification", data)
        .then((res) => {
          if (res.data.success) {
            callback(true);
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
            });
            callback(false);
          }
        });
    },
    selectPeopleFun(index, item) {
      var that=this;
      var person = "";
      this.telPhone = item.phone;
      var arr = [];
      person =this.userList[index]
      this.userList.map(function (item, i) {
        if(item.status){
          arr.push(item.id);
        }
      });
      if(arr.length>3){
        this.$message({ showClose: true, type: "err", message: '同时预约不能超过三人' });
        this.userList[index].status=false;
        return;
      }
      this.frequentContact = arr;
      var obj = {
        peopleId: person.idCode,
        ticketTypeId: 6,
        useStartDate: that.dateTime,
        useEndDate: that.dateTime,
        isFace: false,
      };
      if(item.status){
        this.isCard(obj,  (status) => {
          if (status == true) {
            return true;
          } else {
            person.status = false;
            this.frequentContact = [];
          }
        });
      }
    },
    //获取用户列表
    getUserList() {
      var that = this;
      var data = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 20,
      };
      this.loading = true
      this.$https
        .get(that.appUrl + "wxshopapi/TouristInfo/GetTouristInfoPageList", data)
        .then((res) => {
          this.loading = false
          this.userList = res.data.result.rows.map(function (item) {
            item.status = false;
            return item;
          });
          console.log(this.userList);
          if (res.data.code == 200) {
          } else {
          }
        }).catch(err=>{
          this.loading = false
        });
    },

    getDaoru(arr) {
      this.selectUser(arr.length);
      this.$https.post(this.appUrl + "wxshopapi/ExpectScenic/AddExpectScenicDetails",arr )
        .then((res) => {
          if (res.data.success) {
                this.$message({
                 showClose: true,
                 type: "success",
                 message: '添加成功',
            });
          } else {
              this.$message({
                 showClose: true,
                 type: "success",
                 message: res.data.msg,
            });
          }
        });
    },

    getDaoruXimu(person) {
      var that=this;
      var time = new Date();
      var obj = {
        leaderName: person.name,
        expectPeriodTime: this.forms.dynamicItem[0].expectPeriodTime,
        expectTime: this.dateTime,
        certificateType: "身份证",
        createTime: time,
        updateTime: time,
        leaderIdCard: person.Idcard,
        gName: this.forms.dynamicItem[0].gName,
        groupSum: this.forms.dynamicItem[0].groupSum,
        leaderPhone: person.phone,
      };
      this.$https .post("" + this.appUrl + "wxshopapi/ExpectScenic/AddExpectScenic", obj)
        .then((res) => {
          this.teamId = res.data.result;
           this.userArr.map(function(item){
              item.pId=that.teamId
              return item;
           })
            if(res.data.success){
           this.$message({
                 showClose: true,
                 type: "success",
                 message: "负责人信息添加成功",
            });
            }
          // this.hotList.splice(index, 1)
          if (res.data.code == 200) {
          } else {
          }
        });
    },
    excelFun(data) {

      var that = this;
      var time = new Date();
      this.excelData = data;
      var arr = [];
      this.excelData.map(function (item) {
        var obj = {
          name: item.姓名,
          phone: item.电话,
          idCard: item.身份证号,
          createTime: time,
          updateTime: time,
          pId: that.teamId,
        };
        arr.push(obj);

      });

      if(arr.length>0){
          this.$message({
          showClose: true,
          type: "success",
          message: "导入成功",
        });
      }
      this.userArr=arr;

    },
    creatQrCode(list) {
    var that = this;
    for(var i=0;i<list.length;i++){
        document.getElementById("qrcode"+i).innerHTML="";
    // this.$refs.qrCodeUrl.innerHTML = ""; //清除二维码方法一
      var qrcode = new QRCode(document.getElementById("qrcode"+i), {
        text: list[i].verificationCode, // 需要转换为二维码的内容
        width: 197,
        height: 197,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
         }
      // if(soulId==""){
      //    this.$message({
      //     showClose: true,
      //     type: "error",
      //     message: "预约失败",
      //   });
      // }


      //  qrcode.clear(); //清除二维码
      //  qrcode.makeCode(url) //生成另一个新的二维码
    },
    affirm() {
      var reg_user = /^[\u4e00-\u9fa5]{2,4}$/; //2-4个中文字符正则--姓名
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //电话
      var reg_Idcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; //身份证号码
      if (
        this.formhall.name == null ||
        this.formhall.name == undefined ||
        !reg_user.test(this.formhall.name)
      ) {
        this.$message({
          showClose: true,
          type: "error",
          message: "姓名必须为汉字",
        });
        return;
      }
      if (this.forms.dynamicItem[0].expectPeriodTime == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请预约时段",
        });
        return;
      }
      if (
        this.formhall.Idcard == null ||
        this.formhall.Idcard == undefined ||
        !reg_Idcard.test(this.formhall.Idcard)
      ) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写身份证号码",
        });
        return;
      }
      if (
        this.formhall.phone == null ||
        this.formhall.phone == undefined ||
        !reg_tel.test(this.formhall.phone)
      ) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写电话号码",
        });
        return;
      }
      this.getDaoruXimu(this.formhall);
      this.dialogForm = false;
      this.formLists = { ...this.formhall };
    },
    //团体新增
    addItem() {
      this.dialogForm = true;
    },
    // 团体时间跳动
    SendPhoneCodeFun(forms) {
      let Status = sessionStorage.getItem("Status");
      var reg_user = /^[\u4e00-\u9fa5]{2,12}$/; //2-4个中文字符正则--姓名
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //电话
      var reg_Idcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; //身份证号码
      if (Status === null || Status === undefined) {
        this.$message({
          message: "请登录后查看",
          type: "warning",
        });
      } else {
        if (
          this.forms.dynamicItem[0].expectPeriodTime == "" ||
          this.forms.dynamicItem[0].expectPeriodTime == null
        ) {
          this.$message({
            showClose: true,
            type: "error",
            message: "请选择时间端",
          });
          return;
        }
        if (
          this.forms.dynamicItem[0].gName == "" ||
          this.forms.dynamicItem[0].gName == null ||
          !reg_user.test(this.forms.dynamicItem[0].gName)
        ) {
          this.$message({
            showClose: true,
            type: "error",
            message: "单位名称只能为汉字",
          });
          return;
        }
        if (
          this.forms.dynamicItem[0].groupSum == "" ||
          this.forms.dynamicItem[0].groupSum == null
        ) {
          this.$message({
            showClose: true,
            type: "error",
            message: "请填写团体人数",
          });
          return;
        }
        if (
          this.formhall.name == null ||
          this.formhall.name == undefined ||
          !reg_user.test(this.formhall.name)
        ) {
          this.$message({
            showClose: true,
            type: "error",
            message: "请填写负责人信息",
          });
          return;
        }

       this.getDaoru(this.userArr);
      }
    },
    //  个人详情
    personageFun(hot) {
      var that = this;
      this.centerDialogVisible = true;
      this.wxCode(hot.orderNumber, function (res) {
        that.codeList=res;
        setTimeout(function(){
           that.creatQrCode(res);
        },500)
      });
    },
    // 团体预约
    groupFun(forms) {
      this.dialogVisiblerse = false;
      let date = new Date(this.expectTime); // 增加8小时
      let timer = date.toJSON();
      let time = new Date(+new Date(timer) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
      this.time = time;
      let formList = forms.dynamicItem;
      let formLists = this.formLists;
      let formListe = [{ ...formList[0], ...formLists }];
      this.loading=true
       this.$https.post(this.appUrl +"wxshopapi/ExpectManager/UpdateExpectReduction", { id: this.ticketId, num:  this.forms.dynamicItem[0].groupSum })
        .then((res) => {
          if (res.data.success) {
              this.$https.post("wxshopapi/ExpectScenic/AddExpectScenic", formListe)
                .then((res) => {
                  this.loading=false
                  if (res.data.code == 200) {
                    this.$message({
                      message: "您已预约成功",
                      type: "success",
                    });
                  }
                }).catch(err=>{
                  this.loading=false
                });
          }else{
            this.loading=false
          }
        }).catch(err=>{
          this.loading=false
        });
    },
    // /wxshopapi/ExpectScenic/DeleteAsync//取消预约
    cancelFun(hot) {
      var that = this;
      this.loading=true;
      that.wxCode(hot.orderNumber, function (res) {
        let ids=res.map(item=> {return item.id});
        that.claearYUYue(ids, hot.orderNumber);
      }).catch(err=>{
          that.loading=false
        });
    },
    //预约查看
    GetUserOrderPageListFun(index) {
      var object = {
        userId: this.userId,
        orderType: 1,
        status: index,
        pageindex: 1,
        pageSize: 1000,
      };
      this.loading=true
      this.$https.get("wxshopapi/Orders/GetUserOrderPageList", object)
        .then((res) => {
          this.loading=false
          if(res.data.result.rows.length>0){
            this.hotList = res.data.result.rows;
          }else{
             this.hotList = []
          }
        }).catch(err=>{
        this.loading=false
      });
    },
    appionGetListFun() {
      this.loading=true
      this.$https.get("wxshopapi/ExpectManager/GetList", {
          IsShelve: 2,
          page: 1,
          pageSize: 100,
        })
        .then((res) => {
          this.loading=false
          if(res.data.result){
            this.dataList = JSON.parse(JSON.stringify(res.data.result))
            this.dataList.forEach(item=>{
               item.day = item.expectDate.slice(0, 10);
            })
            this.selectList = res.data.result.map((item) => {
              item.day = item.expectDate.substring(5, 10);
              return item;
            });
            this.startDate = this.selectList[0].expectDate.substring(0, 10);
            this.isShelve = res.data.result[0].isShelve;
            if (this.isShelve == 0) {
              this.isShelves = "100";
            } else if (this.isShelve == 1) {
              this.isShelves = "闭馆";
            }
          }
      }).catch(err=>{
        this.loading=false
      });
    },
    //导航选项
    selectNavFun(index, item) {
      var that=this;
      that.person = item;
      that.selectIndex = index;
      if (index == 0) {
        that.expectType = 1;
        that.appionGetListFun();
      } else if (index == 1) {
        that.expectType = 2;
      } else if (index == 2) {
        that.GetUserOrderPageListFun(1);
        let Status = sessionStorage.getItem("Status");
        if (Status === null || Status === undefined) {
          that.$message({
            message: "请登录后查看",
            type: "warning",
          });
        }
      }
    },
  },
};
</script>

<style >
.dayys{
  font-size: 16px;
}
.a-l-active {
  color: #0078ff !important;
  font-weight: 555;
}
.appointmenttopClass{
  height: 60px;
  line-height: 60px;
}
.appointment-list {
  cursor: pointer;
  width: 300px;
  height: 60px;
  line-height: 60px;
  display: flex;
  font-size: 17px;
  justify-content: space-between;
}
.a-l-item {
  width: 100px;
  cursor: pointer;
}
/* .el-dialog-region {
 height: 390px;
} */
.el-table .cell.el-tooltip {
  text-align: center !important;
}
.ifile-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.router-active {
  display: flex;
  align-items: center;
  height: 60px;
}
.router-active img {
  width: 17px;
  height: 20px;
  margin-right: 6px;
}
.router-link-active {
  color: #000000;
}

/* 弹窗 */
.el-dialog-label {
  display: flex;
  justify-content: center;
  width: 100%;
}
/* 须知 */
.v-modal {
  z-index: 1 !important;
}
.el-dialog-notice {
  width: 1000px;
  height: 810px;
  margin: 0 auto !important;
  background: #ffffff;
  top: 7%;
  padding: 0px 30px;
  border-radius: 15px;
  z-index: 9999 !important;
}
.el-dialog__close {
  color: #fff;
}
.y-advertisement
/* 团体新增 */
.el-form-item__label {
  width: 100px;
  text-align: left !important;
}
.el-button--primary {
  color: #0078ff;
  background-color: #fff;
  border-color: #fff;
  border: none;
}
.appointment-p-item-img {
  width: 18px;
  height: 18px;
}
.appointment-p-item-pull {
  width: 100%;
  display: flex;
  align-items: center;
  color: #0078ff !important;
  /* background-color: #fff; */
  /* border-color: #fff; */
  border: none;
}
.appointment-p-item-pull img {
  padding-right: 5px;
}
.el-form--inline .el-form-item__content {
  display: flex;
  width: 100% !important;
}
.el-form-item__content {
  width: 58%;
  display: flex !important;
}
/* .el-button--primary:focus,
.el-button--primary:hover {
  background: #ffffff;
  border-color: #ffffff;
  color: #0078ff;
} */
/* 查看详情 */
.el-button--text {
  color: #0078ff !important;
}
/* 预约详情 */
.el-dialog {
  margin: 0px auto !important;
  border-radius: 15px;
}
.el-dialog__wrapper {
  z-index: 2015 !important;
}
.el-dialog__wrapper {
  position: fixed;
  /* top: 7%;

    left: 7%; */
}
.el-dialog-content {
  width: 425px;
  /* height: 575px; */
  background: url(/static/img/backdrop.7a72373.png) no-repeat center;
  background-size: 100% 100%;
  /* top: 25%; */
  margin: 5% auto;
}
.el-dialog,
.el-pager li {
  background: #ffffff;
  box-shadow: none;
}
.el-dialog--center .el-dialog__body {
  width: 65%;
  margin: 0 auto;
  text-align: center;
  padding: 0px !important;
}
.el-dialog__header {
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  text-align: center;
  /* padding: 25px 38px 0px; */
}
.el-dialog__body {
  font-size: 16px;
  line-height: 36px;
  padding: 20px 0px;
  /* padding-top: 25px; */
}
.qrcode {
  width: 197px;
  height: 197px;
  margin: 20px auto;
}
.el-dialog-order {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
.el-dialog-spread {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog-spread p:nth-child(1) {
  color: #0078ff;
}
.bottom {
  width: 100%;
  height: 200px;
  border-radius: 20px;

  border-top: 10px solid #d7d7d7;
}
.el-dialog-papers {
  width: 100%;
  margin: 5px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-dialog-papers p:nth-child(1) {
  width: 60%;
  text-align: left;
}
.el-dialog-papers p:nth-child(2) {
  width: 100%;
  text-align: left;
}
.el-button-group {
  /* display: none !important; */
}
.el-dialog-paperse {
  width: 80%;
  margin: 10px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.el-dialog-paperse p {
  color: #0078ff;
}
.el-dialog-paperse p:nth-child(1) {
  width: 60%;
  text-align: left;
}
.el-dialog-paperse p:nth-child(2) {
  width: 100%;
  text-align: left;
}
.el-calendar__header {
  /* border: none !important; */
  padding: 0px 20px !important;
}
.el-calendar__body {
  padding: 20px 0px;
  margin-top: 15px;
}
.el-calendar__title {
  font-size: 18px;
}
.el-calendar-table td.is-selected {
  background-color: #0078ff!important;
  color: #fff;
}
.is-selected {
  width: 165px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0078ff;
  /* color: #ffffff; */
  border-radius: 10px;
  font-size: 24px;
}
.is-selecteds {
  color: #c0c4cc;
}
.y-advertisement {
  width: 100%;
  height: 340px;
}
.y-advertisement img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* 预约订票 */
.expectPeriodTimeClass {
  padding-top: 10px;
}
.expectPeriodTimeClass .el-form-item__label{
  font-size: 16px;
  font-weight: bold;
}
.appointment-date {
}
.appointment-date h4 {
  text-align: left;
  margin: 28px 0;
  padding-top: 0;
}
.a-day-list ul {
  background: #f2f2f8;
  display: flex;
  justify-content: space-around;
  border-radius: 30px;
}
.a-day-list ul li {
  height: 60px;
  line-height: 60px;

  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.appointment-period {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}
.appointment-p-item {
  width: 20%;
  margin-right: 20px;
}
.appointment-p-time {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin-bottom: 14px;
}
.appointment-paragraph {
  width: 285px;
  height: 58px;
  padding-left: 19px;
  box-sizing: border-box;
  line-height: 58px;
  border: 1px solid #e9ebf0;
  border-radius: 10px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.submit-appointment {
  width: 150px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  background: #0078ff;
  border-radius: 34px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff !important;
  margin: 0 auto;
   margin: 30px auto 30px;
}
.tourist {
  font-size: 16px;
  font-family: Microsoft YaHei;

  color: #000000;
}
.tourist-box {
  height: 425px;
  background: #f2f2f8;
  border-radius: 10px;
  padding-left: 70px;
  padding-right: 70px;
  box-sizing: border-box;
  margin-bottom: 60px;
}

.appointment-info {
  position: relative;
  height: 150px;
  background: #ffffff;
  border: 1px solid #e9ebf0;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 20px;
  margin-bottom: 30px;
}
.appointment-info-left {
}
.appointment-info-left .a-info-title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
  margin-bottom: 10px;
  display: flex;
}
.appointment-info-left .a-info-title p {
  margin-left: 15px;
}
.appointment-info-left .a-info-time {
  margin-bottom: 10px;
}
.appointment-info-left .reservation {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  line-height: 34px;
}
.appointment-info-left .a-info-visitors {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 34px;
}
.appointment-info-right {
  display: flex;
  align-items: center;
}
.appointment-info-right .reservation {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #e9ebf0;
  border-radius: 20px;
  margin-right: 20px;
  text-align: center;
}

.appointment-info-right .a-details {
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background: #0078ff;
  border-radius: 20px;
}
.appointment-info-status {
  position: absolute;
  left: 0;
  top: 0;
}
.appointment-info-status .a-i-s-b {
  width: 56px;
  height: 56px;
  background: url(../../static/img/to-used.png) no-repeat; /*待时用 */
  background-size: 100% 100%;
}
.appointment-info-status .a-i-s-c {
  width: 56px;
  height: 56px;
  background: url(../../static/img/userd.png) no-repeat; /* 已使用*/
  background-size: 100% 100%;
}
.appointment-info-status .a-i-s-d {
  width: 56px;
  height: 56px;
  background: url(../../static/img/Cancelled.png) no-repeat; /*已取消 */
  background-size: 100% 100%;
}
.el-calendar-table {
  /* border-collapse: separate;
  border-spacing: 10px 10px; */
}
.el-calendar-table .el-calendar-day {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 153px;
  height: 100px;
  border-radius: 10px;
  font-size: 24px;
}
.el-calendar-table thead th {
  text-align: center;
}
.el-calendar-day p:nth-child(3) {
  margin-top: 10px;
}
.userNameList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.6em;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid rgb(238, 238, 238);
}
.usernamelist {
  font-size: 14px;
  display: flex;
  padding: 10px;
}
.usernamelist .userName{
  font-size: 16px;
  padding-left: 20px;
  width: 120px;
  font-weight: 555;
}
.usernamelist .userName span{
    font-weight:333;
    font-size: 14px;
  }
.usernamelist .idCode{
  font-size: 14px;
  padding-left: 20px;
  width: 220px;
}
.usernamelist .phone{
  font-size: 14px;
  padding-left: 20px;
  width: 220px;
}
.user-delte {
  padding-right: 15px;
}
.el-calendar-table thead {
  width: 1200px;
  height: 60px;
  border-radius: 30px;
  background: #f2f2f8;
  font-size: 18px;
}
/* .dialog-footer {
  margin: -30px auto;
} */
.el-dialog__footer {
  padding: 5px 20px 40px;
}
.el-calendar-table .el-calendar-day:hover {
  background-color: #0078ff !important;
}
/* .el-calendar-table .el-calendar-table__row{
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/view/booking.vue